import React from 'react'
import { Box } from '@mui/joy';

import Profile from '../element/Profile';
import Breadcrumb from '.././component/common/Breadcrumb';

import HeaderTwo from '../component/header/HeaderTwo';
import Footer from '../component/footer/Footer';
import CustomersReviews from '../element/card/customer/CustomersReviews';


const ProfilePage = () => {
 
    return (
        <>
            <Box
                sx={{
                    maxWidth:'100%',
                    padding: '0',
                    boxSizing: 'border-box',
                }}
            >
                <HeaderTwo />
                <Breadcrumb parent="Home" title="Job" title1="Active Job" title2="Bidders" title3="Profile" />
                <Profile/>

                <CustomersReviews/>

                <Footer/>
               
            </Box>



        </>
    )
}

export default ProfilePage;